import { find } from '@/api/sites.api'
import decoder from '@/decoders/site'
import useAPI from '../useAPI'

export const useSite = (params = {}) => useAPI({
  request: find,
  params,
  decoder
})
